import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51fun吃瓜黑料不打烊',
    url: 'http://oheaven.cn/',
    description: '24小时不间断吃瓜黑料资讯平台，覆盖网红翻车、明星八卦、娱乐圈爆料',
    foundingDate: '2025',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: '爆料投稿',
      email: 'hello@oheaven.cn',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '51fun吃瓜黑料不打烊是做什么的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51fun吃瓜黑料不打烊是一个专注于网红翻车、明星八卦、娱乐圈爆料的实时追踪平台，24小时不间断提供吃瓜黑料资讯。',
        },
      },
      {
        '@type': 'Question',
        name: '51fun的内容是否真实可靠？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51fun致力于提供真实、及时的娱乐资讯，内容来源于网友投稿和公开媒体报道。我们鼓励理性吃瓜，内容仅供娱乐阅读，请勿过度解读。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在51fun上进行爆料？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过网站的联系表单或发送邮件至tips@oheaven.cn进行匿名爆料。我们严格保护爆料人的隐私安全。',
        },
      },
      {
        '@type': 'Question',
        name: '51fun是否收费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51fun吃瓜黑料不打烊完全免费，所有吃瓜内容均可免费浏览。我们也提供免费的订阅服务，让您第一时间获取最新爆料。',
        },
      },
    ],
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'http://oheaven.cn/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
      },
    ],
  };

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('company_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      alert('提交成功！感谢您的留言，我们会尽快回复。');
      form.reset();
      return;
    }

    try {
      const url = 'https://readdy.ai/api/form/d92gg900sqa2sn3dngcg';
      const body = new URLSearchParams();
      body.append('name', formData.get('name') as string);
      body.append('email', formData.get('email') as string);
      body.append('message', formData.get('message') as string);
      body.append('source', 'about-page');

      await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      alert('提交成功！感谢您的留言，我们会尽快回复。');
      form.reset();
    } catch {
      alert('提交失败，请稍后重试。您也可以直接发送邮件至 hello@oheaven.cn。');
    }
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>

      <Navbar />
      <main className="min-h-screen">
        {/* Hero */}
        <section className="relative w-full h-[300px] md:h-[420px] overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20dark%20abstract%20composition%20with%20deep%20emerald%20green%20and%20charcoal%20gradients%2C%20mysterious%20cinematic%20atmosphere%20with%20soft%20golden%20light%20leaks%2C%20sophisticated%20editorial%20design%20background%20with%20subtle%20organic%20curve%20patterns%2C%20luxurious%20and%20dramatic%20aesthetic%2C%20no%20text%20no%20people%20just%20pure%20abstract%20visual&width=1600&height=900&seq=about-hero-v1&orientation=landscape"
              alt="关于51fun吃瓜黑料不打烊"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
            <div className="text-center">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 border border-accent-500/30 text-accent-300 text-xs mb-4 whitespace-nowrap">
                关于我们
              </span>
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
                51fun吃瓜黑料不打烊
              </h1>
              <p className="text-background-50/70 text-sm md:text-base max-w-lg mx-auto">
                一个只做真实吃瓜的平台
              </p>
            </div>
          </div>
        </section>

        {/* Breadcrumb */}
        <div className="px-4 md:px-6 max-w-7xl mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>

        {/* Brand Intro - Dark section */}
        <section className="py-16 md:py-24 bg-secondary-950 mx-4 md:mx-6 rounded-3xl">
          <div className="px-4 md:px-6 max-w-4xl mx-auto text-center">
            <span className="text-foreground-500 text-xs font-label tracking-wider uppercase">品牌宣言</span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50 mt-3 mb-8 leading-tight">
              做最真实的<br />吃瓜平台
            </h2>
            <p className="text-foreground-400 text-sm md:text-base max-w-2xl mx-auto leading-relaxed mb-10">
              51fun吃瓜黑料不打烊成立于2025年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为广大"吃瓜群众"提供最新、最全、最热的网红翻车、明星八卦、黑料爆料内容。24小时不间断更新，让你永远站在吃瓜第一线。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="#contact"
                className="whitespace-nowrap cursor-pointer px-8 py-3 rounded-full bg-background-50 text-secondary-900 text-sm font-medium hover:bg-background-100 transition-all"
              >
                联系我们
              </a>
              <a
                href="mailto:hello@oheaven.cn"
                className="whitespace-nowrap cursor-pointer px-8 py-3 rounded-full border border-foreground-400/40 text-foreground-200 text-sm font-medium hover:border-accent-500 hover:text-accent-400 transition-all"
              >
                合作投稿
              </a>
            </div>
          </div>

          {/* Feature Cards */}
          <div className="px-4 md:px-6 max-w-5xl mx-auto mt-16">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
              {[
                { icon: 'ri-shield-check-line', label: '真实爆料' },
                { icon: 'ri-time-line', label: '24小时更新' },
                { icon: 'ri-eye-off-line', label: '隐私保护' },
                { icon: 'ri-global-line', label: '热点全覆盖' },
                { icon: 'ri-fire-line', label: '每日热瓜' },
              ].map((item) => (
                <div
                  key={item.label}
                  className="bg-secondary-800/50 rounded-lg p-5 text-center"
                >
                  <div className="w-8 h-8 mx-auto mb-3 flex items-center justify-center">
                    <i className={`${item.icon} text-foreground-300 text-lg`}></i>
                  </div>
                  <span className="text-foreground-300 text-xs font-medium whitespace-nowrap">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reputation / Testimonials */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <span className="text-foreground-500 text-xs font-label tracking-wider uppercase">用户口碑</span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2">
                吃瓜群众的真实评价
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Testimonial 1 */}
              <div className="bg-secondary-950 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row gap-6 relative overflow-hidden">
                {/* Decorative lines */}
                <div className="absolute top-4 left-6 opacity-20 pointer-events-none">
                  <svg width="50" height="60" viewBox="0 0 50 60" fill="none">
                    <path d="M5 55 Q25 5 45 30" stroke="currentColor" strokeWidth="1.2" className="text-foreground-600" fill="none" />
                    <path d="M0 50 Q20 10 50 25" stroke="currentColor" strokeWidth="0.6" className="text-foreground-700" fill="none" />
                  </svg>
                </div>

                <div className="relative z-10">
                  <div className="text-foreground-200/30 text-6xl font-heading leading-none mb-2">&ldquo;</div>
                  <p className="text-foreground-200 text-sm md:text-base leading-relaxed mb-6">
                    每天打开51fun已经成了我的习惯，这里的瓜又新鲜又全！网红翻车的追踪特别快，比微博还及时，吃瓜体验满分！
                  </p>
                  <p className="text-foreground-400 text-sm font-medium">吃瓜老手小王</p>
                  <p className="text-foreground-600 text-xs">51fun忠实用户 · 使用1年</p>
                </div>
              </div>

              {/* Testimonial 2 */}
              <div className="bg-secondary-950 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row gap-6 relative overflow-hidden">
                <div className="absolute top-4 left-6 opacity-20 pointer-events-none">
                  <svg width="50" height="60" viewBox="0 0 50 60" fill="none">
                    <path d="M5 55 Q25 5 45 30" stroke="currentColor" strokeWidth="1.2" className="text-foreground-600" fill="none" />
                    <path d="M0 50 Q20 10 50 25" stroke="currentColor" strokeWidth="0.6" className="text-foreground-700" fill="none" />
                  </svg>
                </div>

                <div className="relative z-10">
                  <div className="text-foreground-200/30 text-6xl font-heading leading-none mb-2">&ldquo;</div>
                  <p className="text-foreground-200 text-sm md:text-base leading-relaxed mb-6">
                    作为一个娱乐圈从业者，51fun的信息准确度让我惊讶。很多内部消息确实是真的，吃瓜同时还能了解行业动态，强烈推荐！
                  </p>
                  <p className="text-foreground-400 text-sm font-medium">匿名业内人士</p>
                  <p className="text-foreground-600 text-xs">娱乐行业从业者 · 使用8个月</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="py-16 md:py-20 bg-background-100">
          <div className="px-4 md:px-6 max-w-2xl mx-auto">
            <div className="text-center mb-10">
              <span className="text-foreground-500 text-xs font-label tracking-wider uppercase">联系我们</span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2 mb-3">
                有料要爆？欢迎联系
              </h2>
              <p className="text-foreground-600 text-sm leading-relaxed">
                无论是投稿爆料、商务合作还是意见建议，我们都期待你的来信。<br />
                爆料人信息严格保密，请放心投稿。
              </p>
            </div>

            {/* Contact Info */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-8 mb-10">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-mail-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-foreground-900 text-sm font-medium">爆料邮箱</p>
                  <a href="mailto:hello@oheaven.cn" className="text-accent-600 text-sm hover:text-accent-700 whitespace-nowrap cursor-pointer">hello@oheaven.cn</a>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-shield-check-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-foreground-900 text-sm font-medium">严格保密</p>
                  <p className="text-foreground-500 text-sm">保护爆料人隐私安全</p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <form
              data-readdy-form
              id="about-contact-form"
              onSubmit={handleContactSubmit}
              className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70"
            >
              <div className="space-y-5">
                <div>
                  <label htmlFor="contact-name" className="block text-foreground-700 text-sm font-medium mb-2">你的名字</label>
                  <input
                    type="text"
                    id="contact-name"
                    name="name"
                    required
                    placeholder="请输入你的昵称"
                    className="w-full px-4 py-3 rounded-lg bg-background-100 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-accent-500 transition-colors"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-foreground-700 text-sm font-medium mb-2">电子邮箱</label>
                  <input
                    type="email"
                    id="contact-email"
                    name="email"
                    required
                    placeholder="请输入你的邮箱地址"
                    className="w-full px-4 py-3 rounded-lg bg-background-100 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-accent-500 transition-colors"
                  />
                </div>
                <div>
                  <label htmlFor="contact-message" className="block text-foreground-700 text-sm font-medium mb-2">留言内容</label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={4}
                    placeholder="请输入你想说的内容...（最多500字）"
                    className="w-full px-4 py-3 rounded-lg bg-background-100 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-accent-500 transition-colors resize-none"
                  ></textarea>
                  <p className="text-foreground-500 text-xs mt-1">最多500个字符</p>
                </div>
                <button
                  type="submit"
                  className="whitespace-nowrap cursor-pointer w-full py-3 rounded-lg bg-secondary-900 text-background-50 text-sm font-medium hover:bg-secondary-800 transition-all"
                >
                  提交留言
                </button>
              </div>

              {/* Honeypot */}
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="absolute opacity-0 pointer-events-none"
              />
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
